import React, { useCallback } from 'react';
import { useBrainBreakActions } from '../contexts/brainBreakContext';
import type { BrainBreakPlacement } from '../models/BrainBreak';

type NavigationCallback = () => void;

// Overload 1: No arguments - returns handler that takes (event, callback, placement)
export function useBrainBreakNavigation(): (
  e: React.MouseEvent,
  callback: NavigationCallback,
  placement: BrainBreakPlacement,
) => void;

// Overload 2: With callback and placement - returns handler that only takes event
export function useBrainBreakNavigation(
  callback: NavigationCallback,
  placement: BrainBreakPlacement,
): (e: React.MouseEvent) => void;

export function useBrainBreakNavigation(callback?: NavigationCallback, placement?: BrainBreakPlacement) {
  const { showBrainBreak } = useBrainBreakActions();

  const boundHandler = useCallback(
    (e: React.MouseEvent) => {
      e.preventDefault();
      showBrainBreak(callback!, undefined, placement!);
    },
    [showBrainBreak, callback, placement],
  );

  const genericHandler = useCallback(
    (e: React.MouseEvent, cb?: NavigationCallback, pl?: BrainBreakPlacement) => {
      e.preventDefault();
      if (cb && pl) {
        showBrainBreak(cb, undefined, pl);
      } else {
        cb?.();
      }
    },
    [showBrainBreak],
  );

  return callback ? boundHandler : genericHandler;
}
